//Generated File 
export const AUTO_SYSTEM_ACTION = `autoSystemAction`;
export const BIZ_REQUEST_VIEW = `bizRequestView`;
export const DISTRIBUTE_CONTRACTING_COST_TASK_VIEW = `distributeContractingCostOnRealEstateTask`;
export const DMS_DOCUMENTS_ARCHIVE = `RelatedDMSDocuments`;
export const EMPLOYEE_APPROVALS_SCREEN_NAME = `employeeApprovals`;
export const EMPLOYEE_NOTIFICATIONS_SCREEN_NAME = `employeeNotifications`;
export const EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME = `employeeReadNotifications`;
export const END_STOCK_TAKING_TASKS = `EndStockTakingTask`;
export const LEDGER_TRANS_SCREEN_NAME = `LedgerTrans`;
export const PENDING_SYSTEM_ACTION = `pendingSystemAction`;
export const PENDING_TASKS_VIEW = `pendingTasks`;
export const RECORD_AUDIT_TRAIL = `recordAuditTrail`;
export const RECORD_DETAILED_AUDIT_TRAIL = `recordDetailedAuditTrail`;
export const RECORD_INSTALLMENT_PAYMENTS = `installmentPayments`;
export const RELATED_DETAILED_REMARKS = `RelatedDetailedRemarks`;
export const RELATED_LGTSTATUSENTRIES = `RelatedLGTStatusEntries`;
export const RELATED_MEETING_REMARKS = `RelatedMeetingRemarks`;
export const RELATED_QUESTIONAIRS = `RelatedQuestions`;
export const RELATED_REMARKS = `RelatedRemarks`;
export const RELATED_REVISION_DOCS = `RelatedRevisionDocs`;
export const REPORT_CATALOGUE_SCREEN_NAME = `ReportCatalogue`;
export const SAVED_BUSINESS_REQUEST_VIEW = `SavedBusinessRequestView`;
export const SENT_ENTITIES_TO_ANOTHER_SERVER = `sentEntitiesToAnotherServer`;
export const STOCK_AGES_TASK = `StockAgesTask`;
export const UNMATCHED_DEBT_AGES = `unmatchedDebtAges`;
